import { AccountUserLimitModelDto as BoAccountUserLimitDto } from '@treasury/api/bo';
import { AccountUserLimitModelDto as ConsumerAccountUserLimitDto } from '@treasury/api/channel';
import { DomainEntity } from '../../../../shared';

const defaultCompanyUserAccountLimit: BoAccountUserLimitDto = {
    id: 0,
    userAccount: {
        id: 0,
        userId: 0,
    },
    userAccountLimit: {
        dailyLimit: 0,
        perTransactionLimit: 0,
    },
    pendingUserAccountLimit: {
        dailyLimit: 0,
        perTransactionLimit: 0,
    },
};
export class CompanyUserAccountLimit extends DomainEntity<
    BoAccountUserLimitDto | ConsumerAccountUserLimitDto
> {
    public get userAccount() {
        return this.dto.userAccount;
    }

    public get accountNumber() {
        return this.dto.userAccount?.account?.number;
    }

    public get companyDailyLimit() {
        return this.dto.userAccount?.account?.dailyLimit;
    }

    public get companyPerTransactionLimit() {
        return this.dto.userAccount?.account?.perTransactionLimit;
    }

    public get userAccountDailyLimit() {
        return this.dto.userAccountLimit;
    }

    public get pendingUserAccountDailyLimit() {
        return this.dto.pendingUserAccountLimit?.dailyLimit;
    }

    public set pendingUserAccountDailyLimit(value: number | undefined) {
        if (!this.dto.pendingUserAccountLimit) {
            this.dto.pendingUserAccountLimit = {};
        }
        this.dto.pendingUserAccountLimit.dailyLimit = value;
    }

    public get pendingUserAccountPerTransactionLimit() {
        return this.dto.pendingUserAccountLimit?.perTransactionLimit;
    }

    public set pendingUserAccountPerTransactionLimit(value: number | undefined) {
        if (!this.dto.pendingUserAccountLimit) {
            this.dto.pendingUserAccountLimit = {};
        }
        this.dto.pendingUserAccountLimit.perTransactionLimit = value;
    }

    public createDefault(): this {
        return new CompanyUserAccountLimit(defaultCompanyUserAccountLimit) as this;
    }
}

// export type AccountUserLimitModelDto = ModelBaseDto & {
//     userAccount?: UserAccountModelDto;
//     userAccountLimit?: UserAccountLimitModelDto;
//     pendingUserAccountLimit?: UserAccountLimitModelDto;
//   };
